module.exports = __webpack_public_path__ + "static/media/crown_logo.3f1fc7be.png";